import { Box, Flex } from "@chakra-ui/react"
import { FC } from "react"

import { PageHeader } from "common/components/PageHeader/PageHeader"
import { Search } from "features/inventory/search/Search"

const SalesChannelsView: FC = () => (
  <Box p={4}>
    <PageHeader buttonTitle="Add New Channel" title="SalesView Channels" onClick={() => {}} />
    <Flex data-testid="salesChannels" direction="column" p={4}>
      <Search placeholder="Search for sales channels" titleButton="Search sales channel" onSearch={() => {}} />
    </Flex>
  </Box>
)

export { SalesChannelsView }
